import { __decorate, __metadata } from "tslib";
import { IsBoolean } from 'class-validator';
import { LineItemType } from '../../type/order';
import { PriceCalculationParams } from './PriceCalculationParams';
/**
 * Params to use when calculating the price of an audio line item
 */
export class AudioPriceCalculationParams extends PriceCalculationParams {
    constructor(timeRanges, speechToTextAdded) {
        super(timeRanges);
        this.type = LineItemType.Audio;
        this.speechToTextAdded = speechToTextAdded;
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], AudioPriceCalculationParams.prototype, "speechToTextAdded", void 0);
